import { render, staticRenderFns } from "./successMain.vue?vue&type=template&id=c8e6ce20&scoped=true"
import script from "./successMain.vue?vue&type=script&lang=js"
export * from "./successMain.vue?vue&type=script&lang=js"
import style0 from "./successMain.vue?vue&type=style&index=0&id=c8e6ce20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e6ce20",
  null
  
)

export default component.exports